import { Component } from '@angular/core';

@Component({
  selector: 'app-we-build-trust',
  templateUrl: './we-build-trust.component.html',
  styleUrl: './we-build-trust.component.scss'
})
export class WeBuildTrustComponent {

  title: string = 'Construimos confianza a través de resultados comprobados';
  description: string = 'Más de 30 años construyendo con calidad y seguridad. Salud, industria, sector público y vivienda, con innovación y cumplimiento en cada etapa.';

  brands = [
    { src: '/assets/images/partners_webp/abbott-logo.webp', alt: 'Abbott' },
    { src: '/assets/images/partners_webp/frisa.webp', alt: 'Frisa' },
    { src: '/assets/images/partners_webp/grupo-modelo-logo.webp', alt: 'Grupo Modelo' },
    { src: '/assets/images/partners_webp/la-salle-logo.webp', alt: 'La Salle' },
    { src: '/assets/images/partners_webp/Logo_CONADE_(2).svg.webp', alt: 'CONADE' },
    { src: '/assets/images/partners_webp/logo-stiva.webp', alt: 'Stiva' },
    { src: '/assets/images/partners_webp/LOreal-Logo.webp', alt: "L'Oréal" },
    { src: '/assets/images/partners_webp/MVS_Multivision-logo.webp', alt: 'MVS Multivisión' },
    { src: '/assets/images/partners_webp/Nestle.webp', alt: 'Nestlé' },
    { src: '/assets/images/partners_webp/Purina-Logo.webp', alt: 'Purina' },
    { src: '/assets/images/partners_webp/SEMAR_Logo.webp', alt: 'SEMAR' },
    { src: '/assets/images/partners_webp/The_Gillette_Company-Logo.webp', alt: 'Gillette' },
  ];

  images = [
    {
      src: '/assets/images/projects/Remodelación oficinas INE CDMX.png',
      alt: 'Remodelación oficinas INE CDMX',
    },
    {
      src: '/assets/images/projects/Alas-DIF.png',
      alt: 'Alas DIF',
    },
    {
      src: '/assets/images/projects/area industrial.png',
      alt: 'Área Industrial',
    },
    {
      src: '/assets/images/projects/Centro de convencion oaxaca.png',
      alt: 'Centro de Convenciones Oaxaca',
    },
    {
      src: '/assets/images/projects/Construccion gym teresa.png',
      alt: 'Construcción Gym Teresa',
    },
    {
      src: '/assets/images/projects/Remodelacion-areas-marina.png',
      alt: 'Remodelación Áreas Marina',
    },
  ]

}
